<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<!-- <h3 class="ms-2 mt-2">Fatture</h3> -->

<div class="d-flex mt-3 ms-1 mb-2 justify-content-between align-items-center hidden-mobile">
  <h3>Fatture</h3>
  <div class="me-1 custom-select-wrapper">
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <!-- <mat-label>Seleziona anno</mat-label> -->
      <mat-select [(value)]="selectedYear" (selectionChange)="onYearSelected($event)">
        <mat-option *ngFor="let year of years" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="w-100 mb-2 visible-mobile custom-rounded">
  <div class="custom-select-wrapper">
    <mat-form-field appearance="fill" class="mb-0 w-100 custom-rounded" subscriptSizing="dynamic">
      <!-- <mat-label>Seleziona anno</mat-label> -->
      <mat-select class="custom-rounded" [(value)]="selectedYear" (selectionChange)="onYearSelected($event)">
        <mat-option *ngFor="let year of years" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<!-- <mat-card class="mb-3 mb-md-2 col-md-12 d-flex flex-column text-button-card custom-card">
  <div class="d-flex justify-content-between align-items-center mb-0">
    <button
      class="ms-auto"
      matButton="filled"
      color="primary"
      (click)="navigateToNewInvoice()"
    >
    <mat-icon>add</mat-icon>
      New Invoice
    </button>
  </div>
</mat-card> -->

<!-- filter panel -->
<mat-accordion class="me-0 col-md-12 d-flex flex-column">
  <mat-expansion-panel [(expanded)]="filterPanelOpenState">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>filter_list</mat-icon>
        <span class="ms-2">Filtri</span>
      </mat-panel-title>
      <mat-panel-description *ngIf="!filterPanelOpenState">
        {{ getActiveFilterCount() }} filtri attivi
      </mat-panel-description>
    </mat-expansion-panel-header>

    <!-- Basic Filters -->
    <div class="row w-100">
      <!-- Amount Range -->
      <div class="w-sm-25-mobile-25">
        <mat-form-field appearance="outline" floatLabel="always" class="w-100">
          <mat-label>Importo minimo</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="filters.amount_gt"
            name="amount_gt"
            matTooltip="Mostra solo le fatture con importo superiore a questo valore."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          />
          <span matTextPrefix>€&nbsp;</span>
        </mat-form-field>
      </div>
      <div class="w-sm-25-mobile-25">
        <mat-form-field appearance="outline" floatLabel="always" class="w-100">
          <mat-label>Importo massimo</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="filters.amount_lt"
            name="amount_lt"
            matTooltip="Mostra solo le fatture con importo inferiore a questo valore."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          />
          <span matTextPrefix>€&nbsp;</span>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Data di emissione da</mat-label>
        <input
          matInput
          [matDatepicker]="emissionStartPicker"
          [(ngModel)]="filters.emission_date_after"
          name="emission_date_after"
          matTooltip="Mostra solo le fatture emesse a partire da questa data."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="emissionStartPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #emissionStartPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Data di emissione a</mat-label>
        <input
          matInput
          [matDatepicker]="emissionEndPicker"
          [(ngModel)]="filters.emission_date_before"
          name="emission_date_before"
          matTooltip="Mostra solo le fatture emesse fino a questa data."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="emissionEndPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #emissionEndPicker></mat-datepicker>
      </mat-form-field>

      <!-- Company Name -->
      <!-- <div class="w-sm-50"> -->
        <!-- <mat-form-field appearance="outline" floatLabel="always" class="w-100">
          <mat-label>Cerca clienti</mat-label>
          <input
            matInput
            [(ngModel)]="filters.company_name_icontains"
            name="company_name_icontains"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field> -->
      <!-- </div> -->

      <!-- Status -->
      <!-- <div class="w-sm-25">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="filters.status" name="status">
            <mat-option value="">All Statuses</mat-option>
            <mat-option value="paid">Paid</mat-option>
            <mat-option value="unpaid">Unpaid</mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
    </div>

    <!-- Advanced Filters Toggle -->
    <!-- <mat-slide-toggle [(ngModel)]="advancedFilters" class="mb-2">
      Filtri avanzati
    </mat-slide-toggle> -->

    <!-- Advanced Filters (hidden by default) -->
    <div class="advanced-filters" *ngIf="advancedFilters">
      <!-- <mat-divider class="my-3"></mat-divider> -->

      <div class="mt-2 row w-100 mb-0">
        <!-- Emission Date Range -->
        <div class="w-sm-25">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data di emissione da</mat-label>
            <input
              matInput
              [matDatepicker]="emissionStartPicker"
              [(ngModel)]="filters.emission_date_after"
              name="emission_date_after"
              matTooltip="Mostra solo le fatture emesse a partire da questa data."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="emissionStartPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #emissionStartPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="w-sm-25">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data di emissione a</mat-label>
            <input
              matInput
              [matDatepicker]="emissionEndPicker"
              [(ngModel)]="filters.emission_date_before"
              name="emission_date_before"
              matTooltip="Mostra solo le fatture emesse fino a questa data."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="emissionEndPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #emissionEndPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Payment Date Range -->
        <div class="w-sm-25">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data di pagamento da</mat-label>
            <input
              matInput
              [matDatepicker]="paymentStartPicker"
              [(ngModel)]="filters.payment_date_after"
              name="payment_date_after"
              matTooltip="Mostra solo le fatture con termine di pagamento a partire da questa data."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="paymentStartPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #paymentStartPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="w-sm-25">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data di pagamento a</mat-label>
            <input
              matInput
              [matDatepicker]="paymentEndPicker"
              [(ngModel)]="filters.payment_date_before"
              name="payment_date_before"
              matTooltip="Mostra solo le fatture con termine di pagamento fino a questa data."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="paymentEndPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #paymentEndPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="d-flex justify-content-end gap-2 mt-2 w-sm-100">
      <button
        mat-stroked-button
        color="warn"
        (click)="resetFilters(); loadInvoices()"
        matTooltip="Rimuove tutti i filtri applicati."
        [matTooltipShowDelay]="showDelay.value"
        [matTooltipHideDelay]="hideDelay.value"
      >
        <mat-icon>clear</mat-icon>
        Cancella
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="loadInvoices()"
        matTooltip="Applica i filtri selezionati alla tabella."
        [matTooltipShowDelay]="showDelay.value"
        [matTooltipHideDelay]="hideDelay.value"
      >
        <mat-icon>search</mat-icon>
        Applica filtri
      </button>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<!-- Colored cards -->
<!-- <div class="d-flex flex-column flex-md-row justify-content-between align-items-stretch gap-2 mt-3 mb-3 hidden-mobile">
  <mat-card class="flex-grow-1 d-flex flex-column clickable-yellow custom-card-yellow">
    <mat-card-header class="d-flex align-items-center justify-content-center flex-grow-1">
      <mat-card-title class="text-center mb-2">
        <span class="fw-bold me-3">{{ totalInvoices }}</span>Total Invoices
      </mat-card-title>
    </mat-card-header>
  </mat-card>

  <mat-card class="flex-grow-1 d-flex flex-column clickable-blue custom-card-blue">
    <mat-card-header class="d-flex align-items-center justify-content-center flex-grow-1">
      <mat-card-title class="text-center mb-2">
        <span class="fw-bold me-3">{{ paidInvoices }}</span>Paid Invoices
      </mat-card-title>
    </mat-card-header>
  </mat-card>

  <mat-card class="flex-grow-1 d-flex flex-column clickable-pink custom-card-pink">
    <mat-card-header class="d-flex align-items-center justify-content-center flex-grow-1">
      <mat-card-title class="text-center mb-2">
        <span class="fw-bold me-3">{{ totalInvoices - paidInvoices }}</span>
        Unpaid Invoices
      </mat-card-title>
    </mat-card-header>
  </mat-card>
</div> -->

<div class="mt-3 mb-3 d-flex justify-content-between align-items-center">
  <!-- Filter chips -->
  <mat-chip-set aria-label="Filter selection" class="flex-grow-1">
    <mat-chip-option
      *ngFor="let option of filterOptions"
      [value]="option.value"
      [selected]="selectedFilter === option.value"
      (click)="applyFilter(option.value)"
      [matTooltip]="'Mostra solo le fatture: ' + option.name"
      [matTooltipShowDelay]="showDelay.value"
      [matTooltipHideDelay]="hideDelay.value"
    >
      {{option.name}}
    </mat-chip-option>
  </mat-chip-set>

  <!-- Remove the .row wrapper and use d-flex directly -->
  <div class="d-flex justify-content-end">
    <button
      mat-stroked-button
      (click)="invoicingSummaryDownloadPdf()"
      class="ms-2 flex-shrink-0 hidden-mobile"
      style="max-width: 250px;"
      matTooltip="Scarica il riepilogo della situazione contabile in PDF."
      [matTooltipShowDelay]="showDelay.value"
      [matTooltipHideDelay]="hideDelay.value"
    >
      <mat-icon>receipt</mat-icon>
      Situazione contabile
    </button>

    <button
      mat-stroked-button
      (click)="navigateToUploadXML()"
      class="ms-2 flex-shrink-0 hidden-mobile"
      style="max-width: 200px;"
      matTooltip="Importa una fattura caricando un file XML."
      [matTooltipShowDelay]="showDelay.value"
      [matTooltipHideDelay]="hideDelay.value"
    >
      <mat-icon>upload_file</mat-icon>
      Carica file XML
    </button>

    <button
      mat-raised-button
      (click)="navigateToNewInvoice()"
      class="ms-2 flex-shrink-0 primary-button"
      matButton="filled"
      matTooltip="Crea una nuova fattura."
      [matTooltipShowDelay]="showDelay.value"
      [matTooltipHideDelay]="hideDelay.value"
    >
      <mat-icon>add</mat-icon>
      Nuova
    </button>
  </div>
</div>

<mat-card class="mb-3 hidden-mobile total-card">
  <div class="w-100 d-flex mt-2 mb-0 justify-content-between align-items-center">
    
    <h6 class="ms-3 mb-2">Totale fatturato {{ selectedYear }}:</h6>
    
    <div class="me-3 d-flex align-items-center">
      <button
          mat-stroked-button
          class="total-button mb-2"
          (click)="handleAmountInfoClick($event)"
          matTooltip="Informazioni aggiuntive sul fatturato totale."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
        >
        <mat-icon>info</mat-icon>
          <strong>{{ formatTableAmount(totalAmountThisYear-totalAmountCreditThisYear) }}</strong>
      </button>
    </div>

  </div>
</mat-card>

<ng-template #amountInfoDialog let-dialogRef="dialogRef">
  <h2 mat-dialog-title class="m-0 pt-3 ps-3 d-flex align-items-center">
    <mat-icon class="me-2">info</mat-icon> 
    Dettagli Fatturato
  </h2>
  
  <mat-dialog-content class="pt-3">
    <p class="mb-2">
      Il <strong>totale fatturato</strong> rappresenta la somma di tutte le fatture emesse nell'anno selezionato, 
      al netto delle eventuali note di credito registrate.
    </p>
    <p class="mb-0">
      Se la <strong>cassa previdenziale</strong> alla quale appartieni non è l'INPS (nel tuo caso è {{getFundName(organization_data?.favorite_pension_fund)}}), potresti vedere un valore diverso rispetto al totale delle fatture. Questo perchè la percentuale di Rivalsa o Cassa previdenziale, in questo caso, non produce reddito.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="pb-3 pe-3">
    <button
      mat-raised-button
      (click)="invoicingSummaryDownloadPdf()"
      class="ms-2 flex-shrink-0"
      style="max-width: 250px;"
      class="mb-2"
    >
      <mat-icon>receipt</mat-icon>
      Situazione contabile
    </button>

    <button mat-raised-button (click)="dialogRef.close()" class="mb-2">
      <mat-icon>check</mat-icon>
      Ok, capito
    </button>
  </mat-dialog-actions>
</ng-template>

<!-- Add bulk action toolbar (hidden when no selection) -->
<mat-card 
  class="mb-3 hidden-mobile" 
  *ngIf="selectedInvoices.length > 0" 
  class="bulk-actions-toolbar mb-3 p-0"
  >
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <span class="ms-3 fw-bold">{{ selectedInvoices.length }}</span> fatture selezionate
    </div>
    <div class="d-flex gap-2">
      <button
        mat-button
        (click)="bulkDownloadPdf()"
        matTooltip="Scarica il PDF di tutte le fatture selezionate."
        [matTooltipShowDelay]="showDelay.value"
        [matTooltipHideDelay]="hideDelay.value"
      >
        <mat-icon>print</mat-icon>
        Scarica PDF
      </button>
      <button
        mat-button
        (click)="bulkDownloadXml()"
        matTooltip="Scarica l'XML di tutte le fatture selezionate."
        [matTooltipShowDelay]="showDelay.value"
        [matTooltipHideDelay]="hideDelay.value"
      >
        <mat-icon>download</mat-icon>
        Scarica XML
      </button>
      <button
        mat-button
        (click)="bulkMarkAsPaid()"
        matTooltip="Segna come pagate tutte le fatture selezionate."
        [matTooltipShowDelay]="showDelay.value"
        [matTooltipHideDelay]="hideDelay.value"
      >
        <mat-icon>check_circle</mat-icon>
        Segna come pagate
      </button>
      <button
        mat-button
        (click)="clearSelection()"
        matTooltip="Deseleziona tutte le fatture."
        [matTooltipShowDelay]="showDelay.value"
        [matTooltipHideDelay]="hideDelay.value"
      >
        <mat-icon>close</mat-icon>
        Annulla selezione
      </button>
    </div>
  </div>
</mat-card >

<!-- with this we can add a loading state -->
<!-- <div *ngIf="isLoading">Loading invoices...</div> -->

<mat-card
  class="mb-3 mb-md-0 col-md-12 d-flex flex-column custom-card hidden-mobile"
>
  <mat-card-content>
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
      <p class="mt-3">Caricando fatture...</p>
    </div>
    <!-- Show empty state when no data -->
    <div *ngIf="dataSource.filteredData.length === 0 && !isLoading" class="empty-state text-center py-5">
      <img 
        src="izy_image_5_small.png" 
        alt="Nessun cliente"
        class="empty-state-image mb-3"
        style="max-width: 300px; opacity: 1;"
      >
      <h4 class="text-muted">Ancora nessuna fattura qui...</h4>
      <p class="text-muted">Inizia a fatturare!</p>
    </div>

    <table
      *ngIf="dataSource.filteredData.length > 0"
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="announceSortChange($event)"
      class="mat-elevation-z8 hidden-mobile"
    >
      <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->

      <!-- select (#) Column -->
      <!-- Master Checkbox Column for selecting all -->
      <ng-container matColumnDef="selectAll">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            class="custom-checkbox"
            [checked]="isAllSelected()"
            [indeterminate]="isSomeSelected()"
            (change)="toggleSelectAll($event)"
            matTooltip="Seleziona o deseleziona tutte le fatture."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            class="custom-checkbox"
            [checked]="isSelected(element)"
            (change)="toggleSelection(element)"
            (click)="$event.stopPropagation()"
            matTooltip="Seleziona questa fattura."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef class="text-center">Azioni</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <mat-icon
            matButton
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()"
            matTooltip="Altre azioni disponibili per questa fattura."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
            >more_vert</mat-icon
          >
          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item (click)="onRowClick(element)">
              <mat-icon>manage_search</mat-icon>
              <span>Vedi dettagli</span>
            </button>
            <button mat-menu-item (click)="openCustomerPage(element)">
              <mat-icon>account_box</mat-icon>
              <span>Vedi cliente</span>
            </button>
            <button mat-menu-item (click)="duplicateInvoice(element)">
              <mat-icon>copy_all</mat-icon>
              <span>Duplica</span>
            </button>
            <button mat-menu-item (click)="downloadPdf(element.id)">
              <mat-icon>print</mat-icon>
              <span>Download PDF</span>
            </button>
            <button mat-menu-item (click)="sendInvoiceEmail(element.id, element)">
              <mat-icon>outgoing_mail</mat-icon>
              <span>Invia per email</span>
            </button>
            <!-- Add delete button only for ATTESA status -->
            <button 
              *ngIf="element.status === 'ATTESA' || element.status === 'IMPORTATA' || element.status === 'SCARTATA'" 
              mat-menu-item 
              (click)="deleteInvoice(element)"
              class="text-danger"
            >
              <mat-icon color="warn">delete</mat-icon>
              <span>Elimina</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <!-- paidToggle Column -->
      <ng-container matColumnDef="paidToggle">
        <th mat-header-cell *matHeaderCellDef class="text-center">Incassata</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <mat-checkbox
            [(ngModel)]="element.is_paid"
            (change)="togglePaidStatus(element)"
            (click)="$event.stopPropagation()"
            matTooltip="Segna la fattura come incassata o non incassata."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="document_type">
        <th
          mat-header-cell
          *matHeaderCellDef
          
          sortActionDescription="Sort by document type"
        >
          Tipo
        </th>
        <td mat-cell *matCellDef="let element">{{ getDocumentTypeName(element.document_type!) }}{{ element.paper_invoice ? ' (cartacea)' : '' }}</td>
      </ng-container>

      <!-- <ng-container matColumnDef="invoice_name">
        <th
          mat-header-cell
          *matHeaderCellDef
          
          sortActionDescription="Sort by Name"
        >
          Nome
        </th>
        <td mat-cell *matCellDef="let element">{{element.invoice_name}}</td>
      </ng-container> -->

      <!-- Amount Column -->
      <ng-container matColumnDef="amount">
        <th
          mat-header-cell
          *matHeaderCellDef
          sortActionDescription="Sort by Amount"
        >
          Importo
        </th>
        <td mat-cell *matCellDef="let element">{{ formatTableAmount(element.amount, newInvoice?.currency) }}</td>
      </ng-container>

      <!-- Valuta Column -->
      <!-- <ng-container matColumnDef="currency">
        <th mat-header-cell *matHeaderCellDef>Valuta</th>
        <td mat-cell *matCellDef="let element">{{element.currency}}</td>
      </ng-container> -->

      <!-- Company Column -->
      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef>Cliente</th>
        <td mat-cell *matCellDef="let element">
          {{element.company.company_name}}
        </td>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="progressive_number">
        <th mat-header-cell *matHeaderCellDef>Progressivo</th>
        <td mat-cell *matCellDef="let element">{{element.progressive_number}}</td>
      </ng-container>

      <!-- Emission date Column -->
      <ng-container matColumnDef="emission_date">
        <th
          mat-header-cell
          *matHeaderCellDef
          
          sortActionDescription="Sort by Emission"
        >
          Data di emissione
        </th>
        <td mat-cell *matCellDef="let element">{{element.emission_date | date:'dd/MM/yyyy' }}</td>
      </ng-container>

      <!-- Emission date Column -->
      <ng-container matColumnDef="payment_date">
        <th
          mat-header-cell
          *matHeaderCellDef
          
          sortActionDescription="Sort by Payment"
        >
          Termine pagamento
        </th>
        <td mat-cell *matCellDef="let element">{{ element.payment_date | date:'dd/MM/yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th
          mat-header-cell
          *matHeaderCellDef
          sortActionDescription="Sort by Status"
        >
          Stato
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex m-0 align-items-center">
            <mat-chip 
              [color]="getStatusColor(element.status)"
              [ngClass]="{'chip-scartata': element.status === 'SCARTATA', 'chip-accepted': element.status === 'INVIATA'}"
              matTooltip="Stato di invio della fattura all'Agenzia delle Entrate."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              selected>
              {{element.status}}
            </mat-chip>
            <button 
              mat-icon-button 
              class="ms-2 me-0" 
              (click)="handleInfoClick($event)"
              matTooltip="Informazioni aggiuntive sullo stato di invio."
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
              >
              <mat-icon>
                info
              </mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        (click)="onRowClick(row)"
        (mouseenter)="onRowHover(row)"
        [matTooltip]="getRowTooltip(row)"
        matTooltipClass="row-summary-tooltip"
        matTooltipPosition="above"
        [matTooltipShowDelay]="showDelay.value"
        [matTooltipHideDelay]="hideDelay.value"
      ></tr>
    </table>

    <!-- Add the paginator at the bottom of the table -->
     <!-- *ngIf="dataSource.filteredData.length > 0" -->
    <mat-paginator
      [pageSizeOptions]="[10, 20, 50, 100]"
      [pageSize]="20"
      showFirstLastButtons
      class="hidden-mobile"
    >
    </mat-paginator>

    <mat-divider class="visible-mobile"></mat-divider>
  </mat-card-content>
</mat-card>

<!-- Mobile Cards -->
<div class="mobile-cards visible-mobile">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
    <p class="mt-3">Caricando fatture...</p>
  </div>
  <!-- Empty state for mobile -->
  <div *ngIf="filteredInvoices.length === 0 && !isLoading" class="empty-state text-center py-5">
    <img 
      src="izy_image_5_small.png" 
      alt="Nessun cliente"
      class="empty-state-image mb-3"
      style="max-width: 250px; opacity: 1;"
    >
    <h4 class="text-muted">Ancora nessuna fattura qui...</h4>
      <p class="text-muted">Inizia a fatturare!</p>
  </div>

  <mat-card *ngFor="let item of filteredInvoices">

    <mat-card-header class="d-flex mb-1 justify-content-between align-items-center w-100 mobile-header">
      <div class="d-flex justify-content-between align-items-center w-100">
        <h6 class="mb-1 text-start"><strong>{{item.company.company_name || 'N/A'}}</strong></h6>
        <h6 class="mb-1 text-end"><strong>{{ formatTableAmount(item.amount, newInvoice?.currency) }}</strong> </h6>
      </div>
    </mat-card-header>

    <mat-card-content>

      <div class="d-flex m-0 justify-content-between align-items-center">
        <p class="mb-1 text-small"> {{ getDocumentTypeName(item.document_type) || 'Fattura'}} N.{{item.progressive_number || 'N'}} del {{item.emission_date | date:'dd/MM/yyyy'}}</p>
        <!-- Right arrow icon -->
        <mat-icon
          matButton
          [matMenuTriggerFor]="menu"
          matTooltip="Altre azioni disponibili per questa fattura."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
          >more_vert</mat-icon
        >
          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item (click)="onRowClick(item)">
              <mat-icon>manage_search</mat-icon>
              <span>Vedi dettagli</span>
            </button>
            <button mat-menu-item (click)="openCustomerPage(item)">
              <mat-icon>account_box</mat-icon>
              <span>Vedi cliente</span>
            </button>
            <!-- <button mat-menu-item (click)="togglePaidStatus(item)">
              <mat-icon>check</mat-icon>
              <span>Segna come pagata</span>
            </button> -->
            <button mat-menu-item (click)="duplicateInvoice(item)">
              <mat-icon>copy_all</mat-icon>
              <span>Duplica</span>
            </button>
            <button mat-menu-item (click)="downloadPdf(item.id)">
              <mat-icon>print</mat-icon>
              <span>Download PDF</span>
            </button>
            <button mat-menu-item (click)="sendInvoiceEmail(item.id, item)">
              <mat-icon>outgoing_mail</mat-icon>
              <span>Invia per email</span>
            </button>
            <button 
              *ngIf="item.status === 'ATTESA' || item.status === 'IMPORTATA' || item.status === 'SCARTATA'" 
              mat-menu-item 
              (click)="deleteInvoice(item)"
              class="text-danger"
            >
              <mat-icon color="warn">delete</mat-icon>
              <span>Elimina</span>
            </button>
          </mat-menu>
      </div>

      <div class="d-flex mb-0 justify-content-between align-items-center text-muted text-small">
  
        <p 
          *ngIf="item.healthcare_invoice === true || item.paper_invoice === true"
          class="d-inline-flex align-items-center mb-0" 
          [ngClass]="{'text-danger': item.status === 'SCARTATA'}">
          
          <span>{{ getDocumentTypeName(item.document_type) || 'Fattura'}} cartacea - {{ item.status }}</span>
          
          <mat-icon *ngIf="item.status === 'INVIATA'" inline="true" class="ms-1">check</mat-icon>
        </p>
        
        <p 
          *ngIf="item.healthcare_invoice === false && item.paper_invoice === false"
          class="d-inline-flex align-items-center mb-0"
          [ngClass]="{'text-danger': item.status === 'SCARTATA', 'text-accepted': item.status === 'INVIATA'}">
          
          <span>{{ getDocumentTypeName(item.document_type) || 'Fattura'}} elettronica - {{ item.status }}</span>
          
          <mat-icon *ngIf="item.status === 'INVIATA'" inline="true" class="ms-1">check</mat-icon>
        </p>

      </div>

      <!-- <p class="mb-1"><strong>Data:</strong> {{item.emission_date | date:'dd/MM/yyyy'}}</p> -->
      <!-- <p class="mb-1"><strong>Cliente:</strong> {{item.company.company_name || 'N/A'}}</p> -->
      <!-- <p class="mb-1"> {{item.company.company_name || 'N/A'}} </p> -->
      <!-- <p class="mb-1"><strong>Importo:</strong> {{item.amount}} {{item.currency}}</p> -->

      <!-- <mat-chip-list>
        <mat-chip>
          {{item.is_paid ? 'Paid' : 'Unpaid'}}
        </mat-chip>
      </mat-chip-list> -->
    </mat-card-content>

    <div class="d-flex mt-0 mb-0 justify-content-between align-items-center white-bg">
        
        <div class="ms-0 d-flex align-items-center mb-2 paid-toggle">
          <mat-checkbox
            [(ngModel)]="item.is_paid"
            (change)="togglePaidStatus(item)"
            color="primary"
            class="me-0 ms-1"
            matTooltip="Segna la fattura come incassata o non incassata."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
          >
          </mat-checkbox>
          <span class="text-small">{{item.is_paid ? 'Pagata' : 'Non pagata'}}</span>
        </div>

        <button
          mat-stroked-button
          (click)="onRowClick(item)"
          class="me-2"
          matTooltip="Vedi i dettagli completi della fattura."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
        >
          <div class="d-flex justify-content-between align-items-center">
          <p class="mb-0">Dettagli</p>
          <span>
            <mat-icon class="ms-3 mt-1 m-0">chevron_right</mat-icon>
          </span>
          </div>
        </button>

        <!-- <div class="mb-1 d-flex justify-content-end">
          <mat-chip 
            [color]="getStatusColor(item.status)" 
            selected>
            {{item.status}}
          </mat-chip>
        </div> -->
      </div>

  </mat-card>

  <!-- Update paginator to use filteredInvoices length -->
  <!-- <mat-paginator
    *ngIf="filteredInvoices.length > 0"
    [length]="filteredInvoices.length"
    [pageSizeOptions]="[5, 10, 20]"
    [pageSize]="20"
    showFirstLastButtons
  >
  </mat-paginator> -->
</div>

<!-- Sticky footer for total amount -->
<mat-card class="sticky-footer visible-mobile">
  <div class="w-100 d-flex mt-2 mb-3 justify-content-between align-items-center">
    <h6 class="ms-2 mb-0">Fatturato {{ selectedYear }}:</h6>
    <span class="me-2 d-flex align-items-center">
        <button
          mat-icon-button
          class="qi-footer-btn"
          (click)="openQuickInvoice()"
          matTooltip="Fattura Rapida"
          matTooltipPosition="above"
        >
          <mat-icon>flash_on</mat-icon>
        </button>
        <button
          mat-stroked-button
          class="total-button ms-1"
          (click)="handleAmountInfoClick($event)"
          matTooltip="Informazioni aggiuntive sul fatturato totale."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
        >
          <mat-icon>info</mat-icon>
            <strong>{{ formatTableAmount(totalAmountThisYear-totalAmountCreditThisYear) }}</strong>
        </button>
    </span>

  </div>
</mat-card>

<div class="pt-3 mb-3"></div>

<!-- FAB Fattura Rapida -->
<button
  mat-fab
  class="qi-fab"
  (click)="openQuickInvoice()"
  matTooltip="Fattura Rapida"
  matTooltipPosition="left"
>
  <mat-icon>flash_on</mat-icon>
</button>
